import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { useEnqueueRich } from '../context/ToastContext';

export default function HoursToast() {
  const { user } = useAuth();
  const enqueueRich = useEnqueueRich();
  const shownRef = useRef(false);

  useEffect(() => {
    if (!user || shownRef.current) return;
    if (!window.__pendingHoursToast) return;
    delete window.__pendingHoursToast;
    shownRef.current = true;

    fetch('/api/opening-hours')
      .then(r => r.json())
      .then(rows => {
        const now = new Date();
        const todayIdx = now.getDay();

        const fmtTime = (timeStr) => {
          const [h, m] = timeStr.split(':').map(Number);
          const hour = h % 12 || 12;
          const ampm = h < 12 ? 'am' : 'pm';
          return m === 0 ? `${hour}${ampm}` : `${hour}:${String(m).padStart(2, '0')}${ampm}`;
        };

        const today = rows.find(r => r.day_of_week === todayIdx);

        if (today?.is_open) {
          if (!today.open_time || !today.close_time) {
            enqueueRich({ type: 'hours', open: true, subtitle: 'Open all day' });
            return;
          }
          const [oh, om] = today.open_time.split(':').map(Number);
          const [ch, cm] = today.close_time.split(':').map(Number);
          const openMin = oh * 60 + om;
          const closeMin = ch * 60 + cm;
          const nowMins = now.getHours() * 60 + now.getMinutes();
          const isOpen = closeMin === 0 || closeMin <= openMin
            ? nowMins >= openMin || (closeMin > 0 && nowMins < closeMin)
            : nowMins >= openMin && nowMins < closeMin;
          if (isOpen) {
            const closeLabel = closeMin === 0 ? 'midnight' : `${fmtTime(today.close_time)} tonight`;
            enqueueRich({ type: 'hours', open: true, subtitle: `Until ${closeLabel}` });
            return;
          }
        }

        // Find next open slot
        const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        let nextLabel = null;
        for (let i = 0; i <= 7; i++) {
          const checkIdx = (todayIdx + i) % 7;
          const checkDay = rows.find(r => r.day_of_week === checkIdx);
          if (!checkDay?.is_open) continue;
          const timeLabel = checkDay.open_time ? fmtTime(checkDay.open_time) : '';
          if (i === 0) {
            if (checkDay.open_time) {
              const [oh, om] = checkDay.open_time.split(':').map(Number);
              if (now.getHours() * 60 + now.getMinutes() < oh * 60 + om) {
                nextLabel = `Today ${timeLabel}`;
                break;
              }
            }
            continue;
          }
          const dayLabel = i === 1 ? 'Tomorrow' : DAY_NAMES[checkIdx];
          nextLabel = timeLabel ? `${dayLabel} ${timeLabel}` : dayLabel;
          break;
        }

        enqueueRich({ type: 'hours', open: false, subtitle: nextLabel ? `Opens ${nextLabel}` : 'Check back soon' });
      })
      .catch(() => {});
  }, [user, enqueueRich]);

  return null;
}
